import { Component } from '@angular/core';

@Component({
  selector: 'footer-auth',
  templateUrl: './footer-auth.component.html'
})
export class FooterAuthComponent {}
